import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
    mainWrap: {
        justifyContent: 'center',
    },
    container: {
        flexShrink: 1,
        borderWidth: 0.5,
        borderColor: '#EEEEEE',
        backgroundColor: 'white',
        shadowColor: '#000',
        shadowOffset: {
            width: 0,
            height: 1,
        },
        shadowOpacity: 0.2,
        shadowRadius: 1.41,
        elevation: 2,
    },
    flex1: {
        //width:"100%"
        flex: 1,
    },
    flexShrink: {
        flexShrink: 1,
    },
    wrapTop: {
        justifyContent: 'flex-end',
    },
    dropdown: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: 35,
    },
    title: {
        marginVertical: 5,
        fontSize: 16,
    },
    item: {
        padding: 8,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    textItem: {
        flex: 1,
        fontSize: 16,
        color: "#1a1a1a",
        //backgroundColor: "#ee8800"
    },
    icon: {
        width: 20,
        height: 20,
    },
    textError: {
        color: 'red',
        fontSize: 14,
        marginTop: 10,
    },
    input: {
        borderWidth: 0.5,
        borderColor: '#DDDDDD',
        paddingHorizontal: 8,
        marginBottom: 8,
        margin: 6,
        height: 45,
    },
});
